import { Component, OnInit } from '@angular/core';

@Component({
  standalone: false,
  selector:    'app-affiliate-dashboard',
  templateUrl: './affiliate-dashboard.component.html',
  styles:      [],
})
export class AffiliateDashboardComponent implements OnInit {

  constructor() {
  }

  ngOnInit(): void {
  }

}
